"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var Creatable_1 = __importDefault(require("react-select/lib/Creatable"));
var Error_1 = __importDefault(require("../../../common/Error"));
var atoms_1 = require("../../../styles/atoms");
var AC_1 = require("../../AC");
var AdminSetup = function (props) {
    if (!props.visible)
        return null;
    var dispatch = (0, react_redux_1.useDispatch)();
    var id = props.id, content = props.content, _a = props.content, action = _a.action, error = _a.error, formulaForSortingWeightBoost = _a.formulaForSortingWeightBoost, authenticityToken = props.authenticityToken, menuTags = props.tags;
    var _b = (0, react_1.useState)(String(content.sortingWeightBoost)), sortingWeightBoost = _b[0], setSortingWeightBoost = _b[1];
    var _c = (0, react_1.useState)(content.promotion), promotion = _c[0], setPromotion = _c[1];
    var _d = (0, react_1.useState)(content.rating), rating = _d[0], setRating = _d[1];
    var _e = (0, react_1.useState)(content.tags), itemTags = _e[0], setItemTags = _e[1];
    var _f = (0, react_1.useState)(content.adminTags), adminTags = _f[0], setAdminTags = _f[1];
    var handleChangeSortingWeightBoost = function (e) {
        setSortingWeightBoost(e.target.value);
    };
    var handleChangePromotion = function (e) {
        setPromotion(e.target.value);
    };
    var handleChangeRating = function (e) {
        setRating(+e.target.value);
    };
    var handleChangeTags = function (itemTags) {
        setItemTags(formatTags(itemTags));
    };
    var handleChangeAdminTags = function (adminTags) {
        setAdminTags(formatTags(adminTags));
    };
    var handleForm = function (e) {
        var data = new FormData(e.target);
        e.preventDefault();
        (0, AC_1.saveAdminSetup)(dispatch, action, data);
        saveTagsToLocalStorage(itemTags.split(', '));
    };
    var formatTags = function (array) {
        return (Array.isArray(array) ? array : [])
            .map(function (tag) { return tag.value; })
            .join(', ');
    };
    var retrieveLocalStorageTags = function () {
        if (typeof window !== 'object')
            return [];
        var retrievedTagsRaw = window.localStorage.getItem('itemTags');
        return retrievedTagsRaw ? retrievedTagsRaw.split(', ') : [];
    };
    var saveTagsToLocalStorage = function (tags) {
        var retrievedTags = retrieveLocalStorageTags();
        window.localStorage.setItem('itemTags', Array.from(new Set(__spreadArray(__spreadArray([], retrievedTags, true), tags, true))).join(', '));
    };
    var range1To10 = Array.from(Array(10).keys()).slice(1);
    var tagsAutocomplete = __spreadArray(__spreadArray([], menuTags.map(function (item) { return item.name; }), true), retrieveLocalStorageTags(), true).map(function (tag) { return ({ label: tag, value: tag }); });
    return (react_1.default.createElement(atoms_1.Div, { className: "admin-setup" },
        react_1.default.createElement(atoms_1.Div, { className: "sorting-boost" }, formulaForSortingWeightBoost),
        react_1.default.createElement("form", { action: action, method: "post", onSubmit: handleForm },
            error && react_1.default.createElement(Error_1.default, { message: error }),
            react_1.default.createElement("input", { name: "utf8", type: "hidden", value: "\u2713" }),
            react_1.default.createElement("input", { type: "hidden", name: "authenticity_token", value: authenticityToken }),
            react_1.default.createElement("input", { type: "hidden", name: "_method", value: "patch" }),
            react_1.default.createElement("div", { className: "rating" },
                react_1.default.createElement("div", { className: "rating__title" }, "\u0420\u0435\u0439\u0442\u0438\u043D\u0433"),
                range1To10.map(function (i) { return (react_1.default.createElement("label", { key: "".concat(action, "-").concat(i), className: i === rating
                        ? 'btn btn-default btn-sm active'
                        : 'btn btn-default btn-sm' },
                    i,
                    react_1.default.createElement("input", { 
                        // className="hidden"
                        onChange: handleChangeRating, type: "radio", value: i, name: "product[admin_rating]", checked: i === rating }))); })),
            react_1.default.createElement("div", { className: "k-boost" },
                react_1.default.createElement("div", { className: "b-input-field" },
                    react_1.default.createElement("input", { type: "text", name: "product[store_sorting_weight_boost]", value: sortingWeightBoost, onChange: handleChangeSortingWeightBoost }),
                    react_1.default.createElement("label", { className: "active", htmlFor: "boost" }, "\u041A\u043E\u044D\u0444\u0444\u0438\u0446\u0438\u0435\u043D\u0442 \u0431\u0443\u0441\u0442\u0430 \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435"))),
            react_1.default.createElement("div", { className: "admin-setup-tags" },
                react_1.default.createElement("div", { className: "admin-setup-tags__title" }, "\u0422\u044D\u0433\u0438"),
                react_1.default.createElement("input", { type: "hidden", name: "product[tag_list]", value: itemTags }),
                react_1.default.createElement(Creatable_1.default, { formatCreateLabel: function (val) { return "\u0421\u043E\u0437\u0434\u0430\u0442\u044C ".concat(val); }, noOptionsMessage: function () { return 'Введите название тэга'; }, onChange: handleChangeTags, options: tagsAutocomplete, defaultValue: itemTags.split(', ').map(function (item) { return ({
                        value: item,
                        label: item,
                    }); }), isMulti: true })),
            react_1.default.createElement("div", { className: "admin-tags" },
                react_1.default.createElement("div", { className: "admin-tags__title" }, "\u0422\u044D\u0433\u0438 \u0430\u0434\u043C\u0438\u043D\u0430"),
                react_1.default.createElement("input", { type: "hidden", name: "product[admin_tag_list]", value: adminTags }),
                react_1.default.createElement(Creatable_1.default, { formatCreateLabel: function (val) { return "\u0421\u043E\u0437\u0434\u0430\u0442\u044C ".concat(val); }, noOptionsMessage: function () { return 'Введите название тэга'; }, onChange: handleChangeAdminTags, defaultValue: adminTags.length
                        ? adminTags.split(', ').map(function (item) { return ({
                            value: item,
                            label: item,
                        }); })
                        : undefined, isMulti: true })),
            react_1.default.createElement("div", { className: "promotion" }, [
                {
                    value: 'banned',
                    title: 'banned (publishing disabled)',
                },
                {
                    value: 'private',
                    title: 'private (disapprove)',
                },
                {
                    value: 'public',
                    title: 'public (user store)',
                },
                {
                    value: 'listed',
                    title: 'listed (printio store)',
                },
                {
                    value: 'featured',
                    title: 'featured (front page)',
                },
            ].map(function (item, i) { return (react_1.default.createElement("div", { key: "".concat(id, "-").concat(item.value, "-").concat(i) },
                react_1.default.createElement("input", { id: "".concat(id, "-").concat(item.value, "-").concat(i), type: "radio", className: "b-radio", value: item.value, checked: item.value === promotion, onChange: handleChangePromotion, name: "product[promotion]" }),
                react_1.default.createElement("label", { htmlFor: "".concat(id, "-").concat(item.value, "-").concat(i) }, item.title))); })),
            react_1.default.createElement("button", { className: "b-btn b-btn_success b-btn_small" }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"))));
};
exports.default = AdminSetup;
